import React from 'react';
// import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return null;
};

export default React.memo(TheFooter);
